import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class pushnotificationService extends GenericService {
  constructor() {
    super('/notifications', axiosInstance);
  }
}

export default new pushnotificationService(); 